export { default } from './SmartCard'